import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { auth, googleProvider, signInWithPopup } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const [user] = useAuthState(auth);

  const handleSignIn = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (error) {
      console.error('Error signing in:', error);
    }
  };

  const handleSignOut = async () => {
    try {
      await auth.signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <span>Iburtum | مدونة</span>
      </div>
      <div className="navbar-links">
        <Link to="/" className="navbar-link">
          مدونة
          {location.pathname === '/' && (
            <motion.div className="underline" layoutId="underline" />
          )}
        </Link>
        <Link to="/about" className="navbar-link">
          عني
          {location.pathname === '/about' && (
            <motion.div className="underline" layoutId="underline" />
          )}
        </Link>
        {user ? (
          <motion.button
            onClick={handleSignOut}
            className="sign-out-button"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            تسجيل الخروج
          </motion.button>
        ) : (
          <motion.button
            onClick={handleSignIn}
            className="sign-in-button"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            تسجيل الدخول مع Google
          </motion.button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;